const hasActiveSubscription = async (): Promise<boolean> => {
  const serviceWorker = await navigator.serviceWorker.ready;

  if (serviceWorker) {
    const subscription = await serviceWorker.pushManager.getSubscription();
    return subscription !== null;
  }

  return false;
};

export default hasActiveSubscription;
